import { createI18n } from "vue-i18n";
import en from "./locales/en.json";
import nl from "./locales/nl.json";
import de from "./locales/de.json";
import es from "./locales/es.json";

import it from "./locales/it.json";
import fr from "./locales/fr.json";
import hi from "./locales/hi.json";
import zh from "./locales/zh.json";
import pt from "./locales/pt.json";

// Fallback volgorde: cookie > browser > 'en'
const savedLang =
  localStorage.getItem("lang") || navigator.language.split("-")[0] || "en";

const i18n = createI18n({
  legacy: false,
  locale: savedLang,
  fallbackLocale: "en",
  messages: {
    en,
    nl,
    de,
    es,
    it,
    fr,
    hi,
    zh,
    pt
  }
});

export default i18n;
